export const LOGOUT = 'LOGOUT';
export type LOGOUT = typeof LOGOUT;

export const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT';
export type LOGIN_ATTEMPT = typeof LOGIN_ATTEMPT;

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export type LOGIN_SUCCESS = typeof LOGIN_SUCCESS;

export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export type LOGIN_FAILURE = typeof LOGIN_FAILURE;

export const LOGIN_CLEAR_ERRORS = 'LOGIN_CLEAR_ERRORS';
export type LOGIN_CLEAR_ERRORS = typeof LOGIN_CLEAR_ERRORS;



// WEBPACK FOOTER //
// ./src/actions/authentication/login/Types.tsx